import { doBreadcrumb } from './breadcrumb';
import { default as doUserModel } from './userModel';
import { default as doFollowModel } from './followModel';
import { default as doArticleModel } from './articleModel';
import { default as dotagModelModel } from './tagModel';
import { default as doEditInfoModel } from './editInfoModel';
import { default as doAskModel } from './askModel';

const actions = {
  doBreadcrumb,
  ...doUserModel.actions,
  ...doFollowModel.actions,
  ...doArticleModel.actions,
  ...dotagModelModel.actions,
  ...doEditInfoModel.actions,
  ...doAskModel.actions
};

export default actions;
